(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaRecurrenceService', openresaRecurrenceService);

    function openresaRecurrenceService($q, swif, swifRecurrenceService, openresaBookingService, openresaBookableService) {
        'ngInject';
    	var service = {};
    	service.collectionName = 'recurrenteBookings';
    	service.content_type = 'recurrenteReservation';
    	service.COLLECTION_FIELDS = ['checkin', 'checkout', 'state', 'reservation_line', 'reservation_ids'];
        service.COLLECTION_SLOW_FIELDS = ['actions'];
        service.COLLECTION_RECUR_DATA = [
            'recur_month_absolute', 'save_at', 'recur_week_tuesday',
            'confirm_at', 'recur_week_wednesday', 'recur_type', 'date_start',
            'date_end',  'recur_week_sunday', 'recur_periodicity',
            'reservation_ids', 'recur_length_type', 'recur_month_type',
            'date_confirm', 'recur_month_relative_day', 'recur_occurrence_nb',
            'recur_week_saturday', 'recur_month_relative_weight',
            'recur_week_thursday', 'cancel_at', 'recur_week_friday',
            'recur_week_monday'
        ];

        service.fetchSlowFields = fetchSlowFields;
	    service.getCollection = getCollection;
	    service.initCollection = initCollection;

	    service.init = init;
	    service.fetch = fetch;

        service.compute_format_occurrence = compute_format_occurrence;
        service.saveSnapshot = saveSnapshot;
        service.getDatesAvailability = getDatesAvailability;
        service.getDates = getDates;
        service.fromBookingToRecurrence = fromBookingToRecurrence;
        service.fromRecurrenceToBooking = fromRecurrenceToBooking;
        service.fromOccurrenceToBooking = fromOccurrenceToBooking;
        service.computeLastDate = computeLastDate;

	    function getCollection () {
            return swif.collections.getCollection(service.collectionName);
        }

        function initCollection (filter, options) {
            var ret = $q.defer();
            if (!options) {
                options = {};
            }
            var f = {};
            if (filter) {
                f = angular.copy(filter);
            }
            f.fields = _.union(f.fields || [], service.COLLECTION_FIELDS);
            if (options.slowFields) {
                _.union(f.fields, service.COLLECTION_SLOW_FIELDS);
            }
            return swif.collections.createOrUpdate(
                service.collectionName,
                service.content_type,
                f,
                options
            ).then(function (coll) {
                // prepare fetched items
                _.forEach(coll.items, function (elt) {
                    init(elt);
                });
                return coll;
            });
        }

        function fetchSlowFields (recurrences, filter) {
            var f = {};
            if (filter) {
                f = angular.copy(filter);
            }
            swif.data.addFilter(f, 'id', 'in', _.pluck(recurrences, 'id'));
            swif.data.setLimit(f, 0);
            if (!f.fields) {
                f.fields = service.COLLECTION_SLOW_FIELDS;
            }
            return swif.data.get(service.content_type, undefined, f)
            .then(function (data) {
                swif.data.updateFromList(data, recurrences);
                return recurrences;
            });
        }

        function init (model) {
            if (!model) {
                model = {};
            }
            var defaults = {
                occurrences: [],
                _lastDate: ''
            };
            _.defaults(model, defaults);
            openresaBookingService.init(model);
            // ensure content_type of the record
            model._type = service.content_type;
            service.saveSnapshot(model);
            return model;
        }

        function _fetchRecurrence (model) {
            var filter = {};
            filter.fields = service.COLLECTION_RECUR_DATA;
            return swif.data.get(service.content_type, model.id, filter)
            .then(function (data) {
                _.merge(model, data);
                return true;
            });
        }

        // load ALL data (lines, availability, etc...)
        // @TODO: fetch bookings, lines and recurrence data
        function fetch (model) {
            return $q.all([
                _fetchRecurrence(model),
                openresaBookingService.fetch(model, {booking: false})
            ]);
        }

        function compute_format_occurrence (request, recurrence) {
            var val = {
                // partner_id: request.partner_id && request.partner_id[0] || false,
                // resources: [],
                // price: 0.0,
                length: swif.date.getHours(
                            recurrence.checkin,
                            recurrence.checkout,
                            'user'
                        ) * 3600.0
            };
            /* NOTES: Do not compute resources from resources,
               Do it by itself on getDates() callback

             _.forEach(recurrence.lines, function (line) {
                val.resources.push({
                    prod_id: line.resource.id,
                    qty: line.qty,
                    price: line.pricelist_amount,

                });
            }); */

            return val;
        }

        /*
         * @param request: the request Object containg all the bookings and recurrences
         * @param recurrence: the recurrence Object we want to clear the occurrences
         * @notes: browse the bookings Array, and remove those attached to the 'recurrence' parameter
        */
        service.removeOccurrences = function (request, recurrence) {
            var bookingsToRemove = _.remove(request.bookings, function (booking) {
                return booking.recurrence === recurrence;
            });
            _.forEach(bookingsToRemove, function (booking) {
                if (booking.id) {
                    request.deletedBookings.push(booking);
                }
            });
        };

        service.addOccurrence = function (request, recurrence, occurrence) {
            occurrence.recurrence = recurrence;
            // @TODO: check if the booking does not already exists on bookings
            request.bookings.push(occurrence);
        };

        service.removeRecurrence = function (request, recurrence) {
            var recurrencesToDelete = _.remove(request.recurrences, function (recur) {
                return recur === recurrence;
            });
            _.forEach(recurrencesToDelete, function (recur) {
                service.removeOccurrences(request, recur);
                if (recur.id) {
                    request.deletedRecurrences.push(recur);
                }
            });
        };

        function getDatesAvailability (request, recurrence, occurrences) {
            var dates = {};
            var prod_ids = [];
            // ensure to skip lines of bookings that are to be replaced
            // by current occurrences
            var skip_ids = [];
            _.forEach(request.deletedBookings, function (booking) {
                skip_ids = _.union(skip_ids, booking.reservation_line || []);
            });
            _.forEach(recurrence.lines, function (line) {
                // compute the prod_ids parameter
                var prod_id = line.product_id ? line.product_id[0]: false;
                if (prod_id && !_.contains(prod_ids, prod_id)) {
                    prod_ids.push(prod_id);
                }
            });
            // _occId is a temp ID used to bind server results
            // with the temp objects easily
            var _occId = 1;
            _.forEach(occurrences, function (item) {
                // then compute the dates parameter
                item._occId = _occId.toString();
                _occId++;
                dates[item._occId] = {
                    start: item.checkin,
                    end: item.checkout
                };
            });
            // now, perform request to the server
            return swif.data.callKw(
                'reservation_line',
                'get_availability',
                [dates],
                {prod_ids: prod_ids, skip_ids: skip_ids}
            ).then(function (res) {
                // finally, bind result to the related occurrences
                _.forOwn(res, function (value, valueId) {
                    var occurrence = _.find(occurrences, {_occId: valueId});
                    if (occurrence) {
                        _.forEach(occurrence.lines, function (line) {
                            var prodId = line.product_id ? line.product_id[0]: 0;
                            line.available_qty = value.availability[prodId] || 0.0;
                        });
                        // as available_qty was changed,
                        // recompute availability on booking
                        openresaBookableService._computeLineAvailability(occurrence);
                    }
                });
            });
        }

        // @return: generated bookings (already attached to request and recur)
        function getDates (request, recurrence) {
            var format_occurrence = service.compute_format_occurrence(request, recurrence);
            // clear the existing recurrences before adding the new ones
            service.removeOccurrences(request, recurrence);
            return swifRecurrenceService.getDates(recurrence, format_occurrence)
            .then(function () {
                var ret = [];
                // link the generated occurrences to the request Object
                _.forEach(recurrence.occurrences, function (occurrence) {
                    occurrence.lines = angular.copy(recurrence.lines);
                    var newModel = service.fromOccurrenceToBooking(occurrence);
                    service.addOccurrence(request, recurrence, newModel);
                    ret.push(newModel);
                });
                // after that, remove the 'occurrences' attribute, not use anymore
                delete recurrence.occurrences;
                service.computeLastDate(request, recurrence);
                service.saveSnapshot(recurrence);
                // finally, compute the
                return service.getDatesAvailability(
                    request, recurrence, ret
                ).then(function () {
                    return ret;
                });
            });
        }

        // store the new snapshot of the recurrence, to compare with further updates
        // and display a message to user: 'you must generate dates again'
        function saveSnapshot (recurrence) {
            var snapshot = angular.copy(recurrence);
            delete snapshot._snapshot;
            recurrence._snapshot = snapshot;
            recurrence._snapshotDiff = false;
        }

        function linkRecurrenceDatetime (model) {
            var maxDate = function (d1, d2) {
                if (d1 && d2) {
                    return d1 > d2 ? d1 : d2;
                } else {
                    return Boolean(d1) ? d1 : d2;
                }
            };
            if (model._type === 'recurrenteReservation' && model.checkin && model.checkout) {
                model.date_start = model.checkin;
                model.date_end = maxDate(model.date_end, model.checkout);
            }
        }

        function fromOccurrenceToBooking (model) {
            var newModel = angular.copy(model);
            delete newModel.id;
            openresaBookingService.init(newModel);
            _.forEach(newModel.lines, function (line) {
                delete line.id;
            });
            delete newModel.resources;
            newModel._bookingNotice = _.min(newModel.lines, 'bookable_notice').bookable_notice;
            openresaBookableService._computeLineAvailability(newModel);
            return newModel;
        }

        // from booking to recurrence
        function fromBookingToRecurrence (model) {
            var newModel = angular.copy(model);
            if (newModel.id) {
                delete newModel.id;
            }
            _.forEach(newModel.lines, function (line) {
                if (line.id) {
                    delete line.id;
                }
            });
            service.init(newModel);
            linkRecurrenceDatetime(newModel);
            return newModel;
        }

        // from recurrence to booking
        function fromRecurrenceToBooking (model) {
            var newModel = angular.copy(model);
            if (newModel.id) {
                delete newModel.id;
            }
            _.forEach(newModel.lines, function (line) {
                if (line.id) {
                    delete line.id;
                }
            });
            openresaBookingService.init(newModel);
            return newModel;
        }

        function computeLastDate (model, recurrence) {
            var val = '';
            _.forEach(model.bookings, function (booking) {
                if (booking.recurrence === recurrence && booking.checkout > val) {
                    val = booking.checkout;
                }
            });
            recurrence._lastDate = val;
            return recurrence._lastDate;
        }

    	return service;
    }

})();
